// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1sceb","alert":"SettungsInbox_alert__2ti1W"};